import { Plane, Globe, Luggage } from "lucide-react";

export default function SimpleLoader() {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
      <div className="flex gap-4">
        <Plane className="w-6 h-6 text-[#5b6f00] animate-bounce [animation-delay:-0.3s]" />
        <Globe className="w-6 h-6 text-[#5b6f00] animate-bounce [animation-delay:-0.15s]" />
        <Luggage className="w-6 h-6 text-[#5b6f00] animate-bounce" />
      </div>
    </div>
  );
}